module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: (_vm.wwdSectionVChanged),
      expression: "wwdSectionVChanged"
    }],
    staticClass: "main-section _whatWeDo"
  }, [_c('div', {
    staticClass: "container-custom -section-bg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "-section-col col-xs-7 col-padding"
  }, [_c('div', {
    staticClass: "section-mainInfo-block _onWhite"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.wwHeader.main))]), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: (_vm.dsSectionVChanged),
      expression: "dsSectionVChanged"
    }],
    staticClass: "main-section _realizationSolution"
  }, [_c('div', {
    staticClass: "container-custom -section-bg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "-section-col col-xs-7 col-padding"
  }, [_c('div', {
    staticClass: "section-mainInfo-block _onGreen"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.dsHeader.main))]), _vm._v(" "), _c('h3', {
    staticClass: "block-underTitle"
  }, [_vm._v("opartych o procesory sygnałowe")]), _vm._v(" "), _vm._m(2)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "nothingImpossible-section"
  }, [_c('div', {
    staticClass: "container-custom"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-padding"
  }, [_c('h2', {
    staticClass: "text-center text-uppercase  s56 m-t-70 m-b-80"
  }, [_vm._v("\n                            Nie ma dla nas "), _c('br'), _vm._v("\n                            rzeczy "), _c('span', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: (_vm.imSectionVChanged),
      expression: "imSectionVChanged"
    }],
    staticClass: "s68 w700 f-myriadProBold"
  }, [_vm._v(_vm._s(_vm.imHeader.main))])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('section', {
    staticClass: "individualSolutions-section"
  }, [_c('div', {
    staticClass: "container-custom -section-bg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-padding"
  }, [_c('h2', {
    staticClass: "text-center text-uppercase s56 c-white m-t-0 m-b-20"
  }, [_vm._v("\n                            Rozwiązania dopasowane"), _c('br'), _vm._v("\n                            do "), _c('span', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: (_vm.hardSectionVChanged),
      expression: "hardSectionVChanged"
    }],
    staticClass: "s68 w700 f-myriadProBold"
  }, [_vm._v(_vm._s(_vm.hardHeader.main))]), _vm._v(" założeń\n                        ")])])]), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('section', {
    staticClass: "contact-section"
  }, [_c('div', {
    staticClass: "container-custom -section-bg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-padding"
  }, [_c('h2', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: (_vm.contactSectionVChanged),
      expression: "contactSectionVChanged"
    }],
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.contactHeader.main))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(9), _vm._v(" "), _c('terminal-component')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header-section"
  }, [_c('div', {
    staticClass: "container-custom"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-padding col-xs-6"
  }, [_c('img', {
    staticClass: "img-max-width",
    attrs: {
      "src": require("./assets/images/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-padding col-xs-6 text-right"
  }, [_c('p', {
    staticClass: "c-gold s18 m0"
  }, [_vm._v("ZADZWOŃ DO NAS")]), _vm._v(" "), _c('p', {
    staticClass: "section-number c-black2 s28 f-myriadProBold"
  }, [_c('a', {
    staticClass: "contact-link-black",
    attrs: {
      "href": "tel:603-588-575"
    }
  }, [_vm._v("+48 603 588 575")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "block-text"
  }, [_vm._v("\n                                Programowanie to nasza pasja. Od kilkunastu lat budujemy dedykowane rozwiązania oparte o\n                                procesory sygnałowe.\n                                Specjalizujemy się w algorytmach przetwarzania obrazów oraz analizie danych w czasie\n                                rzeczywistym.\n                                "), _c('br'), _c('br'), _vm._v("\n                                W naszej pracy staramy się łączyć najnowsze technologie z prostotą dnia codziennego.\n                                Dzięki temu jesteśmy w stanie budować zaawansowane produkty, które idealnie współgrają z\n                                otaczającym nas światem.\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "block-text"
  }, [_vm._v("\n                                W ciągu naszej kilkunastoletniej praktyki nigdy nie korzystaliśmy z półśrodków! Budujemy nasze rozwiązania wykorzystując tylko najlepsze komponenty.\n                                Przy projektowaniu systemów opartych o procesy sygnałowe, współpracujemy z takimi firmami jak Texas Instruments® czy Altera®.\n                                "), _c('br'), _c('br'), _vm._v("\n                                Moc obliczeniową staramy się zawsze dopasować do postawionego zadania.\n                                Dzięki połączeniu najnowszych technologii jesteśmy w stanie zagwarantować maksymalną wydajność i bezpieczeństwo budowanych systemów.\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "-section-col table-col _middle col-xs-5 col-padding"
  }, [_c('img', {
    staticClass: "img-max-width",
    attrs: {
      "src": require("./assets/images/cpu-iso2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "-section-col table-col _middle col-xs-7 col-padding"
  }, [_c('div', {
    staticClass: "section-mainInfo-block"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v("DSP")]), _vm._v(" "), _c('p', {
    staticClass: "block-text"
  }, [_vm._v("\n                                    Skorzystaj z naszego doświadczenia w budowie zaawansowanych systemów! Dzięki wykorzystaniu procesorów sygnałowe do realizacji\n                                    algorytmów przetwarzania danych jesteśmy w stanie diametralnie przyspieszyć Twoje środowisko pracy.\n                                ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "-section-col table-col _middle col-xs-7 col-padding"
  }, [_c('div', {
    staticClass: "section-mainInfo-block"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v("FPGA")]), _vm._v(" "), _c('p', {
    staticClass: "block-text"
  }, [_vm._v("\n                                    Nasze produkty w dużej mierze opieramy o programowalne struktury logiczne (FPGA), w\n                                    których realizowane są równoległe algorytmy obróbki sygnałów oraz obrazów pochodzących z czujników radarowych,\n                                    kamer termowizyjnych (IR) czy dziennych (TV).\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "-section-col table-col _middle col-xs-5 text-right col-padding"
  }, [_c('img', {
    staticClass: "img-max-width",
    attrs: {
      "src": require("./assets/images/laptop-iso.png"),
      "alt": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row m-b-60"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "-section-col table-col _middle col-xs-5 col-padding"
  }, [_c('img', {
    staticClass: "img-max-width",
    attrs: {
      "src": require("./assets/images/card-iso.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "-section-col table-col _middle col-xs-7 col-padding"
  }, [_c('div', {
    staticClass: "section-mainInfo-block"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v("ARM")]), _vm._v(" "), _c('p', {
    staticClass: "block-text"
  }, [_vm._v("\n                                    Świat urządzeń "), _c('i', [_vm._v("embedded")]), _vm._v(" również nie ma przed nami tajemnic!\n                                    Wykorzystujemy najnowsze rozwiązania procesorów z rodziny ARM. W połączeniu z RTOS Linux udostępniając tym samym w pełni otwartą architekturę programo-sprzętową.\n                                ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-padding"
  }, [_c('p', {
    staticClass: "section-text text-center"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "clientOurPan-section"
  }, [_c('div', {
    staticClass: "container-custom -section-bg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "-section-col table-col _middle col-xs-5"
  }, [_c('img', {
    staticClass: "img-max-width",
    attrs: {
      "src": require("./assets/images/throne.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "-section-col table-col _middle col-xs-7 col-padding"
  }, [_c('div', {
    staticClass: "section-mainInfo-block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_c('div', {
    staticClass: "display-table"
  }, [_c('div', {
    staticClass: "display-table-cell _middle",
    staticStyle: {
      "font-size": "130px",
      "line-height": "98px",
      "padding-right": "10px"
    }
  }, [_vm._v("\n                                            Nasz\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "display-table-cell _middle",
    staticStyle: {
      "line-height": "51px"
    }
  }, [_vm._v("\n                                            klient "), _c('br'), _vm._v("\n                                            Pan\n                                        ")])])]), _vm._v(" "), _c('p', {
    staticClass: "block-text"
  }, [_vm._v("\n                                    Opowiedz nam o swoim problemie, a my dołożymy wszelkich starań, aby jego rozwiązanie\n                                    było dla Ciebie w pełni satysfakcjonujące.\n                                    "), _c('br'), _c('br'), _vm._v("\n                                    Nie boimy się wyzwań! Maksymalnie funkcjonalne, spełniające wszystkie wymagania, a\n                                    zarazem zaawansowane technologicznie -\n                                    właśnie tak określane są nasze produkty przez naszych Klientów.\n                                    "), _c('br'), _c('br'), _vm._v("\n                                    Dołącz do nich już dziś!\n                                ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "trustUs-section"
  }, [_c('div', {
    staticClass: "container-custom -section-bg"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {}
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-padding"
  }, [_c('h2', {
    staticClass: "text-uppercase s56 m-t-0 m-b-20"
  }, [_c('b', [_vm._v("Oni nam "), _c('span', {
    staticClass: "s68 w700 f-myriadProBold"
  }, [_vm._v("zaufali")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-padding"
  }, [_c('div', {
    staticClass: "section-table display-table"
  }, [_c('div', {
    staticClass: "display-table-row"
  }, [_c('div', {
    staticClass: "section-table-cell display-table-cell"
  }, [_c('div', {
    staticClass: "section-item"
  }, [_c('a', {
    attrs: {
      "target": "blank",
      "href": "https://www.pctechnologies.net/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/trusted/pctechnologies.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section-table-cell display-table-cell"
  }, [_c('div', {
    staticClass: "section-item"
  }, [_c('a', {
    attrs: {
      "target": "blank",
      "href": "http://www.wze.com.pl/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/trusted/wze-zielonka.jpg"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section-table-cell display-table-cell"
  }, [_c('div', {
    staticClass: "section-item"
  }, [_c('a', {
    attrs: {
      "target": "blank",
      "href": "http://www.kontron.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/trusted/kontron.png"),
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "display-table-row"
  }, [_c('div', {
    staticClass: "section-table-cell display-table-cell"
  }, [_c('div', {
    staticClass: "section-item"
  }, [_c('a', {
    attrs: {
      "target": "blank",
      "href": "http://www.prexer.com.pl/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/trusted/prexer.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section-table-cell display-table-cell"
  }, [_c('div', {
    staticClass: "section-item"
  }, [_c('a', {
    attrs: {
      "target": "blank",
      "href": "http://www.pitradwar.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/trusted/pitradwar.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section-table-cell display-table-cell"
  }, [_c('div', {
    staticClass: "section-item"
  }, [_c('a', {
    attrs: {
      "target": "blank",
      "href": "http://www.wat.edu.pl/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/trusted/wat.jpg"),
      "alt": ""
    }
  })])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "-section-col col-xs-4 col-padding"
  }, [_c('div', {
    staticClass: "section-mainInfo-block"
  }, [_c('h4', {
    staticClass: "block-title"
  }, [_vm._v("Adres")]), _vm._v(" "), _c('p', {
    staticClass: "block-text"
  }, [_vm._v("\n                                ul. Jana Olbrachta 124/51"), _c('br'), _vm._v("\n                                01-373, Warszawa\n                            ")]), _vm._v(" "), _c('h4', {
    staticClass: "block-title"
  }, [_vm._v("Kontakt")]), _vm._v(" "), _c('p', {
    staticClass: "block-text"
  }, [_c('a', {
    staticClass: "contact-link-white",
    attrs: {
      "href": "mailto:wiwtechdsp@op.pl"
    }
  }, [_vm._v("e-mail:\n                                    wiwtechdsp@op.pl")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "contact-link-white",
    attrs: {
      "href": "tel:603-588-575"
    }
  }, [_vm._v("tel. 603-588-575")])]), _vm._v(" "), _c('h4', {
    staticClass: "block-title"
  }, [_vm._v("Dane firmy")]), _vm._v(" "), _c('p', {
    staticClass: "block-text"
  }, [_vm._v("\n                                WIW TECHDSP Sp. z o. o."), _c('br'), _vm._v("\n                                REGON: 368311947"), _c('br'), _vm._v("\n                                NIP: 522-310-05-92\n                            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-143026a4!./~/vue-loader/lib/selector.js?type=template&index=0!./app/App.vue
// module id = 174
// module chunks = 0